import React, { useEffect, useState, useRef } from "react";
import { addhttp, i18nKeys, I18n } from "../utils/functions";
import "./Footer.scss";


const Footer = (data) => {
    const i18n = new I18n(data.whitelabel?.userID);

    return (
        <div className="container-footer">
            <a
                className="createdBy"
                href={
                    data.campaign.clientLink
                    ? addhttp(data.campaign.clientLink)
                    : addhttp(data.metadata.userLink)
                }
                target="_blank"
                rel="noreferrer"
            >
                {/* TODO: Should come from the whitelabel and not be hardcoded!!!*/}
                {data.whitelabel && data.whitelabel.userID === "8C1AC22B-A754-433B-83FB-0885D6DA296A"
                    ? "Powered By"
                    : i18n.getText(i18nKeys.createdBy)
                }{" "}
                {data.campaign.clientName
                ? data.campaign.clientName
                : data.metadata.userName}
            </a>

            <>
                {" "}
                <a
                href={data.whitelabel && data.whitelabel
                    ? addhttp(data.whitelabel.logoLink)
                    : "https://www.sosha.ai"
                }
                target="_blank"
                rel="noreferrer"
                >
                <img
                    src={
                    data.whitelabel &&
                    data.whitelabel.logoURL
                        ? data.whitelabel.logoURL
                        : "https://pic.speechifai.tech/408F8EE2-8F7B-45B7-8F6E-90B895FFF476.jpg"
                    }
                    data-cy="landing-logo"
                    alt={
                        data.whitelabel && data.whitelabel.platformName
                            ? data.whitelabel.platformName : "SoSha"
                        }
                />
                </a>
                <a
                href={
                    data.whitelabel
                    ? data.whitelabel.termsLink
                    : "https://app.speechifai.tech/terms.html"
                }
                target="_blank"
                className="terms"
                rel="noreferrer"
                data-cy="landing-terms"
                >
                {i18n.getText(i18nKeys.termsOfUse)}
                </a>
            </>
        </div>
    );

};

export default Footer;